import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MailIcon, MapPinIcon, PhoneIcon, SmartphoneIcon } from 'lucide-react';
import { business, mapEmbedSrc, navLinks, socials } from '../data/site';
import { smsProgram } from '../data/smsProgram';
const mapsHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${business.address.street}, ${business.address.city}, ${business.address.state} ${business.address.zip}`)}`;
export function SiteFooter() {
  return <footer id="contact" className="w-full bg-ink text-white" data-id="element-399" data-mp="38hi6cdmhnf57">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-8 lg:py-20" data-id="element-400" data-mp="33iot8mb45q5k">
        <div className="grid grid-cols-[minmax(0,1fr)] gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,520px)] lg:gap-16" data-id="element-401" data-mp="33ix64e78kvgr">
          <div className="min-w-0" data-id="element-402" data-mp="2ylyfi5ms76nb">
            <img src={business.logoUrl} alt={`${business.name} logo`} className="h-auto w-full max-w-[300px] object-contain object-left" data-id="element-403" data-mp="11rk5i1cax9qi" />
            <p className="mt-6 max-w-[420px] text-[16px] leading-relaxed text-chalk/70" data-id="element-404" data-mp="15qbyu7lqt3cs">
              Specializing in professional results. Give us a call today to
              learn more about the East End Automotive Way!
            </p>

            <a href={business.phoneHref} className="mt-7 inline-flex items-center gap-3 whitespace-nowrap rounded-md bg-brand px-6 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-405" data-mp="vuig26hfkdmk">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-406" data-mp="1tf4styit114r" />
              Call {business.phone}
            </a>

            <dl className="mt-10 grid gap-6 sm:grid-cols-2" data-id="element-407" data-mp="1epgzbjgv76rl">
              <div data-id="element-408" data-mp="1jpbqlo4jxyd6">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-409" data-mp="1jotm647qkdu6">
                  <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-410" data-mp="27ee3kio8r31c" />
                  Address
                </dt>
                <dd className="mt-2 text-[15px] leading-relaxed text-chalk/85" data-id="element-411" data-mp="2m2nz6ekgh77p">
                  <a href={mapsHref} target="_blank" rel="noreferrer" className="hover:text-brand-light" data-id="element-412" data-mp="2m0jv9wmk487f">
                    {business.address.street}
                    <br data-id="element-413" data-mp="2d16hirregxgw" />
                    {business.address.city}, {business.address.state}{' '}
                    {business.address.zip}
                  </a>
                </dd>
              </div>
              <div data-id="element-414" data-mp="234trc3v2d1qw">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-415" data-mp="235d0av2qkfss">
                  <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-416" data-mp="1ybilo61zmr0k" />
                  Hours
                </dt>
                <dd className="mt-2 space-y-1 text-[15px] text-chalk/85" data-id="element-417" data-mp="1pcx5uinwhq3h">
                  {business.hours.map(h => <p key={h.days} data-id="element-418" data-mp="1kdu16zbu1lw1">
                      <span className="text-chalk/55" data-id="element-419" data-mp="1kcsoyrj2ytcq">{h.days}:</span> {h.time}
                    </p>)}
                </dd>
              </div>
              <div data-id="element-420" data-mp="3r0rk07nvfnuo">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-421" data-mp="3r1b2bphfoe98">
                  <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-422" data-mp="3w30ej8ge6xyw" />
                  Text the shop
                </dt>
                <dd className="mt-2 text-[15px] text-chalk/85" data-id="element-423" data-mp="8vy3q777rcyd">
                  <a href={business.smsHref} className="hover:text-brand-light" data-id="element-424" data-mp="8vet7bjw7qud">
                    {business.phone}
                  </a>
                </dd>
              </div>
              <div data-id="element-425" data-mp="3db7kdapl76pl">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-426" data-mp="3d8bodrxaus3s">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-427" data-mp="3m2q39tdx40md" />
                  Email
                </dt>
                <dd className="mt-2 break-all text-[15px] text-chalk/85" data-id="element-428" data-mp="2pl3mzl2zs371">
                  <a href={`mailto:${business.email}`} className="hover:text-brand-light" data-id="element-429" data-mp="2pj0umued9xz5">
                    {business.email}
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <div className="min-w-0" data-id="element-430" data-mp="25kk2nf76ubd4">
            <div className="overflow-hidden rounded-xl border border-white/10 bg-charcoal" data-id="element-431" data-mp="2k7day0iaigvt">
              <iframe title={`Map to ${business.name}`} src={mapEmbedSrc} loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="block h-[300px] w-full border-0 sm:h-[340px] lg:h-[400px]" data-id="element-432" data-mp="2fgwxwhidsx9z" />
              <a href={mapsHref} target="_blank" rel="noreferrer" className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t border-white/10 px-5 py-4 text-[14px] font-semibold text-chalk/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-433" data-mp="335g6ky5cfc2l">
                <span className="inline-flex min-w-0 items-center gap-2" data-id="element-434" data-mp="13vq5212h8s1z">
                  <MapPinIcon className="h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-435" data-mp="3fhiir9prc913" />
                  274 Warehouse Rd, Oak Ridge, TN
                </span>
                <span className="whitespace-nowrap text-brand-light" data-id="element-436" data-mp="3aq0i6mrncagn">
                  Get directions
                </span>
              </a>
            </div>

            <nav aria-label="Footer" className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-437" data-mp="2woo2mcgeeava">
              {navLinks.map(link => <Link key={link.to} to={link.to} className="text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/60 transition-colors duration-150 ease-out hover:text-white" data-id="element-438" data-mp="30phqj5tubpo6">
                  {link.label}
                </Link>)}
            </nav>

            <ul className="mt-6 flex flex-wrap gap-2.5" data-id="element-439" data-mp="q01a8dalq1e1">
              {socials.map(s => <li key={s.label} data-id="element-440" data-mp="oivx53ueqey0">
                  <a href={s.href} target="_blank" rel="noreferrer" className="inline-flex rounded-md border border-white/15 px-3.5 py-2 text-[13px] font-semibold text-chalk/75 transition-colors duration-150 ease-out hover:border-brand hover:text-white" data-id="element-441" data-mp="ojxaxg2t5fjf">
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <nav aria-label="Policies" className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-[14px] text-chalk/80" data-id="element-442" data-mp="12aiwxdnk65lj">
          <Link to={smsProgram.privacyPath} className="underline underline-offset-4 hover:text-white" data-id="element-443" data-mp="xhhfoyzvptys">
            Privacy Policy
          </Link>
          <Link to={smsProgram.termsPath} className="underline underline-offset-4 hover:text-white" data-id="element-444" data-mp="1q04vbyw3wgsh">
            SMS Terms
          </Link>
        </nav>

        <div className="mt-8 flex flex-col gap-2 border-t border-white/10 pt-7 text-[13px] text-chalk/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-445" data-mp="1l7k3v40oafs4">
          <p data-id="element-446" data-mp="1xich6o6eu0ix">
            © {new Date().getFullYear()} {business.name}. All rights reserved.
          </p>
          <p data-id="element-447" data-mp="22h5vgititvk5">{business.contact} · EEAutomotiveRepair.com</p>
        </div>
      </div>
    </footer>;
}